import ProfilePreview from './ProfilePreview'

export default [{
  path: '/profile',
  name: 'Profile',
  component: ProfilePreview,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Profile'}
}]



// WEBPACK FOOTER //
// ./src/pages/users/router.js